module.exports = __webpack_public_path__ + "static/images/components/NavigationArrow/images/arrow-right-disabled-small.cd001a26.png";


//////////////////
// WEBPACK FOOTER
// ./components/NavigationArrow/images/arrow-right-disabled-small.png
// module id = 2645
// module chunks = 11